export default __webpack_public_path__ + "static/media/vote0-disabled.ca752aca.png";